// axiosInstance.js
import axios from 'axios';

const userId = localStorage.getItem("userId");
const instance = axios.create({
    baseURL: `${ process.env.REACT_APP_API_ENDPOINT }/getUserDetail/${userId}`,
});

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Handle unauthorized error:
            // 1. Clear user session/token from local storage or state management
            localStorage.clear(); 
            // 2. Redirect to login page
            window.location.href = '/login'; // Or use React Router's navigate
        }
        else {
            console.log('okkk');
        }
        return Promise.reject(error);
    }
);

export default instance;